module.exports = __webpack_public_path__ + "img/noip2.347a0ea1.jpg";